// ============================================================
// Roadmap & Strategy module manifest.
//
// 2026-08-15. Owners: fullstack-lead (spec synthesis, SPEC_ROADMAP.md) +
//   firebase-expert (impl) + ui-designer (.rm-* CSS) + data-architect
//   (schema §2) + auth-security (Rules §2.6).
//
// DIRECTOR + ADMIN ONLY — confidential like pricing. No industry-pack
// role receives roadmap.*; director holds `*`, admin holds
// `__ALL_EXCEPT_TENANT_CONFIG__` (client) / isAdmin() fast-path (Rules).
// Dual-gated: visible() checks roadmap.read AND firestore.rules rejects
// every other role at the read.
//
// ONE sidebar entry in section 'admin' (above Settings). Route id
// 'roadmap'. Page IA: Roadmap (Timeline | Board | List) · Objectives ·
// Strategy · Risks & Decisions.
// ============================================================

export default {
  id:          'roadmap',
  name:        'Roadmap & Strategy',
  version:     '1.0.0',
  description: 'Company roadmap (lanes × quarters), objectives & key results, risk register, decision log, and go-to-market strategy board. Directors and admins only.',

  load: () => import('./index.js'),

  routes: [
    {
      id:      'roadmap',
      label:   'Roadmap & Strategy',
      icon:    '🧭',
      section: 'admin',
      sidebarPosition: 10,
      visible: (role, hasPerm) => typeof hasPerm === 'function' && hasPerm('roadmap.read'),
      mount:   'mountRoadmap',
      unmount: 'unmountRoadmap'
    }
  ],

  schemas: [
    'roadmap',          // ONE tenant-scoped collection with a `Kind` discriminator
    'roadmap-audit'     // append-only audit (Before/After/Summary/ByUid/ByRole)
  ],

  permissions: [
    'roadmap.read',
    'roadmap.write',
    'roadmap.manage'    // import / reset / hard-delete
  ],

  dependencies: [],

  fitsIndustries: ['manufacturing', 'trading', 'services', 'retail'],

  // Dashboard KPI widget — director/admin only (structural: no other role
  // gets it, and mountRoadmapQuarterKpiWidget re-checks the role).
  dashboardWidgets: [
    { id: 'roadmap-quarter-kpi', label: 'Roadmap', section: 'kpi', order: 8,
      defaultRoles: ['director', 'admin'] }
  ]
};
